import { useEffect } from "react";

type ToastProps = {
  message: string;
  onClose: () => void;
};

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 px-4">
      <div className="fade-in flex items-center gap-2 rounded-lg border border-primary-800 bg-primary-950/95 px-4 py-3 text-sm text-background-50 backdrop-blur">
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-[11px] text-primary-950">
          <i className="ri-check-line"></i>
        </span>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}